import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { postPeoplePaginatedNewImplementation } from '../../../Api'
import useStore from '../../StorePeople/Store'
import ExpandedFilters from '../ExpandedFilters/ExpandedFilters'
import buildQuery from '../PeopleQueryBuild'
import Name from './Name/Name'
import JobTitle from './JobTitle/JobTitle'
import City from './City/City'
import State from './State/State'
import { CircularProgress } from '@material-ui/core'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import styles from './styles.module.css'

export default function SearchFilters () {
  const {
    fullName,
    title,
    city,
    state,
    page,
    setPage,
    setDataResults,
    streetAddress,
    postalCode,
    country,
    currentCompany,
    requiredFields,
    recordRecency,
    businessCategories,
    sourceURLs,
    firstRender,
    setFirstRender,
    setQueryStore,
    isQueryLoading,
    setIsQueryLoading,
    setDownloadQueryStore,
    orFields,
    // R33: New property ownership filters
    mostRecentPropertyPurchaseDate,
    propertiesOwnedDatePurchased,
    propertiesOwnedDateSold
  } = useStore()

  const [alert, setAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: '#EF3688',
    actions: []
  })
  const [query, setQuery] = useState()

  const [searchFilterRequest] = useMutation(
    ({ page, query }) => postPeoplePaginatedNewImplementation(page, query),
    {
      onMutate: () => {
        setIsQueryLoading(true)
      },
      onSuccess: data => {
        if (data?.data?.errors || data.status >= 400) {
          setQueryStore(query)
          const errMsg = data?.data?.errors?.[0] || 'Something went wrong'

          if (errMsg.includes('people:paginate')) {
            setAlert({
              open: true,
              title: 'Feature not enabled',
              body: 'You need to enable "people.paginate" on your account to use this feature. Contact our team to request that this feature be enabled.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setAlert(a => ({ ...a, open: false }))
                },
                {
                  label: 'Contact support',
                  onClick: () => {
                    window.location.href = 'mailto:support@datafiniti.co'
                    setAlert(a => ({ ...a, open: false }))
                  }
                }
              ]
            })
          } else if (errMsg === 'No results found for provided query.') {
            setAlert({
              open: true,
              title: 'No results found',
              body: 'Try broadening your filters to find matches.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setAlert(a => ({ ...a, open: false }))
                }
              ]
            })
          }
          setIsQueryLoading(false)
          return
        }

        setQueryStore(query)
        setDataResults(data)
        setDownloadQueryStore({ query: '', id: '' })
      },
      onError: error => {
        setAlert({
          open: true,
          title: 'Error',
          body: error.message || 'An error occurred',
          color: '#EF3688',
          actions: [
            {
              label: 'Ok',
              onClick: () => setAlert(a => ({ ...a, open: false }))
            }
          ]
        })
      },
      onSettled: () => {
        setIsQueryLoading(false)
      }
    }
  )

  useEffect(
    () => {
      if (!firstRender) {
        const newQuery = buildQuery(
          fullName,
          title,
          city,
          state,
          streetAddress,
          postalCode,
          country,
          currentCompany,
          requiredFields,
          recordRecency,
          businessCategories,
          sourceURLs,
          orFields,
          // R33: New property ownership filters
          mostRecentPropertyPurchaseDate,
          propertiesOwnedDatePurchased,
          propertiesOwnedDateSold
        )
        setQuery({ query: newQuery })
        setPage(1)
      } else {
        setFirstRender(false)
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      fullName,
      title,
      city,
      state,
      streetAddress,
      postalCode,
      country,
      currentCompany,
      requiredFields,
      recordRecency,
      businessCategories,
      sourceURLs,
      orFields,
      // R33: New property ownership filters
      mostRecentPropertyPurchaseDate,
      propertiesOwnedDatePurchased,
      propertiesOwnedDateSold
    ]
  )

  useEffect(
    () => {
      if (!firstRender && query) {
        searchFilterRequest({ page, query })
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      query,
      page,
      searchFilterRequest
    ]
  )

  useEffect(() => {
    return () => setFirstRender(true)
  }, [setFirstRender])

  return (
    <section className={styles.searchFiltersContainerPeople}>
      <h1 className={styles.searchFilterPeople}>Search filters</h1>
      <div className={styles.searchFilterContainerPeopleComponents}>
        <Name />
        <JobTitle />
        <City />
        <State />
        <ExpandedFilters />
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          {isQueryLoading ? (
            <CircularProgress
              disableShrink
              size={25}
              style={{ color: '#065E88', marginBottom: '5px' }}
            />
          ) : null}
        </div>
      </div>

      <BaseAlert
        open={alert.open}
        title={alert.title}
        body={alert.body}
        color={alert.color}
        style={{ width: '320px' }}
        actions={alert.actions}
        onClose={() => setAlert(a => ({ ...a, open: false }))}
      />
    </section>
  )
}
